import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FormControl, TextField, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setWeight as updateWeight } from "../../redux/userSlice";
import { MinorUserContext } from "../../context/UserNameProvider";
import Question from "../../components/Question";
import { inputLabelSx, textAreaSx } from "../../lib/uiformatting";
import ContinueButton from "../../components/ContinueButton";
import setPageAndDeferNavigate from "../../lib/setPageAndDeferNavigate";

export default function MinorWeight() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { returning = false } = location.state || {};
    const theme = useTheme();

    const user = useSelector((state) => state.user);
    const [weight, setWeight] = useState(user.weight || "");
    const [error, setError] = useState("");
    const { firstName, isMinor } = useContext(MinorUserContext);

    const handleChange = (e) => {
        const value = e.target.value;
        setWeight(value);

        if (!value) {
            setError("This field is required.");
        } else if (value <= 0 || value > 400) {
            setError("Please enter a valid weight.");
        } else {
            setError("");
        }
    };

    const handleBack = () => {
        if (user.age > 14 && user.age < 18) {
            setPageAndDeferNavigate(dispatch, '/minor/solo-treatment', () =>
                navigate('/minor/solo-treatment', { state: { returning: returning } })
            );
        } else {
            setPageAndDeferNavigate(dispatch, '/minor/consent', () =>
                navigate('/minor/consent', { state: { returning: returning } })
            );
        }
    };

    return (
        <Question
            onBack={handleBack}
            title="What is the minor's weight? (in lbs.)"
            subtitle={`Please enter ${isMinor ? firstName + "'s" : "your"} weight as it helps our providers while creating prescriptions.`}
            input={
                <>
                    <FormControl sx={{ width: "100%" }} required>
                        <TextField
                            label="Enter a number..."
                            type="number"
                            inputProps={{ inputMode: "decimal" }}
                            variant="outlined"
                            color="secondary"
                            multiline
                            rows={2}
                            sx={{
                                ...textAreaSx, width: "100%",
                                "& .MuiInputLabel-root": {
                                    backgroundColor: theme.palette.background.paper,
                                    padding: "0 32px",
                                    transition: "all 0.2s ease-in-out",
                                },
                            }}
                            InputLabelProps={{
                                sx: {
                                    ...inputLabelSx,
                                    "& .MuiInputLabel-shrink": {
                                        backgroundColor: theme.palette.background.paper,
                                    },
                                }
                            }}
                            autoComplete="off"
                            value={weight}
                            onChange={handleChange}
                            error={error !== ""}
                            helperText={error}
                        />
                    </FormControl>
                    <ContinueButton
                        sx={{ mt: 3 }}
                        onClick={() => {
                            dispatch(updateWeight(weight));
                            setPageAndDeferNavigate(dispatch, '/minor/instructions', () =>
                                navigate('/minor/instructions', { state: { returning } })
                            );
                        }}
                        disabled={!weight || error !== ""}
                        title="Continue"
                        selected={Boolean(weight) && error === ""}
                    />
                </>
            }
        />
    );
};
